import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@td/shared_utils';

import { DrugListMap } from '../../types/drugListMap';
import { RefState } from '../../types/refState';
import MedicationAvailabilityEditForm from './medication-availability-edit-form';
import { getManagedStates, isFederalLevel } from '../../utils/drug-list-map';
import { EditIcon } from '../../../icons';

export const SERVICE_LINE_MANAGED_STATES_TRANSLATION_KEYS = {
  general_medical: 'denied_states',
  mental_health: 'approved_states',
  dermatology: 'denied_states',
  primary_care: 'denied_states',
};

const MedicationServiceLineAvailability = ({ serviceLine, drugListMaps, refStates, drugId }) => {
  const [editMode, setEditMode] = useState(false);

  return (
    <table className="fields">
      <tbody>
        <tr>
          <th>
            <I18n scope="medication_formularies.details.availability.labels" text="service_line" />
          </th>
          <td>
            <I18n scope="medication_formularies.details.availability.service_lines" text={serviceLine} />
          </td>
        </tr>
        <tr>
          {!editMode && (
            <Fragment>
              <th>
                <I18n
                  scope="medication_formularies.details.availability.labels"
                  text={SERVICE_LINE_MANAGED_STATES_TRANSLATION_KEYS[serviceLine]}
                />
              </th>
              <td>
                {isFederalLevel(drugListMaps) && (
                  <I18n scope="medication_formularies.details.availability.managed_states" text="all_states" />
                )}
                {drugListMaps.length === 0 && (
                  <I18n
                    scope="medication_formularies.details.availability.managed_states"
                    text="no_states"
                  />
                )}
                {!isFederalLevel(drugListMaps) &&
                  drugListMaps.length > 0 &&
                  getManagedStates(drugListMaps, refStates).map(refState => (
                    <li key={refState.stateCd}>{refState.stateName}</li>
                  ))}
              </td>
              <td className="medication-availability-actions">
                <button onClick={() => setEditMode(true)}>
                  <span>
                    <I18n scope="medication_formularies.details.availability.actions" text="edit" />
                  </span>
                  <EditIcon />
                </button>
              </td>
            </Fragment>
          )}
          {editMode && (
            <td colSpan={3}>
              <MedicationAvailabilityEditForm
                refStates={refStates}
                drugListMaps={drugListMaps}
                serviceLine={serviceLine}
                onComplete={() => setEditMode(!editMode)}
                drugId={drugId}
              />
            </td>
          )}
        </tr>
      </tbody>
    </table>
  );
};

MedicationServiceLineAvailability.propTypes = {
  serviceLine: PropTypes.oneOf(['general_medical', 'mental_health', 'dermatology', 'primary_care']).isRequired,
  drugListMaps: PropTypes.arrayOf(DrugListMap).isRequired,
  refStates: PropTypes.arrayOf(RefState).isRequired,
  drugId: PropTypes.string.isRequired
};

export default MedicationServiceLineAvailability;
